/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { InspectionOrderResponseDto } from '../models/inspection-order-response-dto';
import { orderControllerCreateChargeOrder } from '../fn/order/order-controller-create-charge-order';
import { OrderControllerCreateChargeOrder$Params } from '../fn/order/order-controller-create-charge-order';
import { orderControllerCreateInspectionOrder } from '../fn/order/order-controller-create-inspection-order';
import { OrderControllerCreateInspectionOrder$Params } from '../fn/order/order-controller-create-inspection-order';
import { orderControllerCreateProductOrder } from '../fn/order/order-controller-create-product-order';
import { OrderControllerCreateProductOrder$Params } from '../fn/order/order-controller-create-product-order';

@Injectable({ providedIn: 'root' })
export class OrderService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `orderControllerCreateInspectionOrder()` */
  static readonly OrderControllerCreateInspectionOrderPath = '/api/order/inspection';

  /**
   * Lp 검사 주문 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerCreateInspectionOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerCreateInspectionOrder$Response(params: OrderControllerCreateInspectionOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<InspectionOrderResponseDto>> {
    return orderControllerCreateInspectionOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * Lp 검사 주문 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerCreateInspectionOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerCreateInspectionOrder(params: OrderControllerCreateInspectionOrder$Params, context?: HttpContext): Observable<InspectionOrderResponseDto> {
    return this.orderControllerCreateInspectionOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<InspectionOrderResponseDto>): InspectionOrderResponseDto => r.body)
    );
  }

  /** Path part for operation `orderControllerCreateChargeOrder()` */
  static readonly OrderControllerCreateChargeOrderPath = '/api/order/charge';

  /**
   * 충전 주문 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerCreateChargeOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerCreateChargeOrder$Response(params: OrderControllerCreateChargeOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return orderControllerCreateChargeOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * 충전 주문 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerCreateChargeOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerCreateChargeOrder(params: OrderControllerCreateChargeOrder$Params, context?: HttpContext): Observable<boolean> {
    return this.orderControllerCreateChargeOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `orderControllerCreateProductOrder()` */
  static readonly OrderControllerCreateProductOrderPath = '/api/order/product';

  /**
   * 충전 주문 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerCreateProductOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerCreateProductOrder$Response(params: OrderControllerCreateProductOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return orderControllerCreateProductOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * 충전 주문 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerCreateProductOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerCreateProductOrder(params: OrderControllerCreateProductOrder$Params, context?: HttpContext): Observable<boolean> {
    return this.orderControllerCreateProductOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
